import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const BurgerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  color: ${COLORS.gray40};
`;

export default BurgerWrapper;
